import { useEffect } from 'react'
import { createFileRoute, Outlet } from '@tanstack/react-router'

import { initLogger } from '@/lib/logger.ts'
import { useSyncManager } from '@/hooks/use-sync-manager.ts'
import { AppLoading } from '@/components/app-loading'
import { DefaultLayout } from '@/components/layout/default-layout'
import { useDexieDb } from '@/db/dexie-context'
import { useAuth } from '@/features/auth/hooks/use-auth'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
  ssr: false,
})

const logger = initLogger('authenticated-layout')

function AuthenticatedLayout() {
  const auth = useAuth()
  const navigate = Route.useNavigate()
  const db = useDexieDb({ safe: true })

  useSyncManager({
    enabled: !!auth.user?.id && !!db, // Only enable when user is authenticated and DB is ready
    syncOnMount: true, // Sync immediately when authenticated
  })

  useEffect(() => {
    if (!auth.user && !auth.loading) {
      logger.info('Redirecting to login')
      navigate({ to: '/auth/login' })
    }
  }, [auth.loading, auth.user])

  if (!auth.user || !db) return <AppLoading />

  return <DefaultLayout>{auth.user && <Outlet />}</DefaultLayout>
}
